import React from 'react';
import {PageCover, Portfolio, Partners, Map, Contact,Footer, SolidFactory,FactoryInformation,BusinessProcess,OurProducts,ServiceFaq} from 'components/section';

const Service = () => {
 return (
  <div className="Service padding-cover">
    <PageCover 
      url="service"
      title = "OUR SERVICES" 
      text = "고체 화장품 전문 제조공장 동구밭 팩토리에서 브랜드를 완성하세요"
    />
    <SolidFactory/>
    <FactoryInformation className="bgColor-lightGrey"/>
    <BusinessProcess />
    <OurProducts />
    <Portfolio className="bgColor-lightGrey"/>
    <Partners />
    <ServiceFaq className = "bgColor-lightGrey"/>
    <Map type ="withText"/>
    <Contact className="bgColor-lightGrey"/>
    <Footer />
   
  </div>
 );
}

export default Service;